// 封装axios请求

import axios from 'axios'
import * as isPlainObject from 'lodash/isPlainObject'
import { constants } from '@/global'
import { protocolFixed, uuid } from '@/utils'
const { ERROR_CODE, BASE_PATH, API_PREFIX, API_ORIGIN } = constants

class HttpRequest {
  constructor() {
    this.timeout = 60 * 1000
    this.baseURL = BASE_PATH
    this.method = 'get'
    this.withCredentials = true
    this.headers = {
      'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
    }
    this.baseConfig = {
      timeout: this.timeout,
      baseURL: this.baseURL,
      method: this.method,
      withCredentials: this.withCredentials,
      headers: this.headers
    }
  }
  // 合并参数
  mergeOptions(config = {}) {
    let { headers = {}, url, baseURL, ...rest } = config
    let { headers: baseHeaders, ...base } = this.baseConfig
    headers = { ...baseHeaders, ...headers }
    if (!baseURL) {
      url = /^(http|https):/.test(url) ? url : `${API_PREFIX}${url}`
    } else {
      rest.baseURL = baseURL
    }
    // 以/api开头的接口需要加上withCredentials
    const withCredentials =
      /^\/api/.test(url) || (API_ORIGIN && url.indexOf(API_ORIGIN) === 0)
    if (withCredentials) {
      headers.bid = uuid()
    }
    return { ...base, ...rest, withCredentials, headers, url }
  }
  // 设置拦截器
  setInterceptor(instance, config, resolveError) {
    instance.interceptors.request.use(
      config => {
        let { params = {} } = config
        params['__'] = +new Date()
        return { ...config, params }
      },
      error => Promise.reject(error)
    )
    instance.interceptors.response.use(
      async res => {
        if (
          res.data &&
          res.data.data &&
          typeof res.data.data == 'object' &&
          res.data.errno - 0 === 0
        ) {
          res.data.data = this.fixData(res.data.data)
        }
        try {
          return await this.asyncHandleResponse(res)
        } catch (e) {
          return resolveError ? Promise.reject(e) : null
        }
      },
      error => {
        return Promise.reject(error)
      }
    )
  }
  // 处理response和error
  asyncHandleResponse(response) {
    return new Promise((resolve, reject) => {
      const { status, statusText, data } = response
      const { error, errno } = data
      if (/^([23])\d{2}$/.test(status)) {
        if (errno === ERROR_CODE.SUCCESS) {
          return resolve(data)
        } else {
          const errInfo = { data: data.data, error, errno }
          return reject(errInfo)
        }
      } else {
        const errInfo = { statusText, status }
        return reject(errInfo)
      }
    })
  }
  request(url, options, resolveError) {
    // 用户的参数 + 默认参数 = 总共的参数
    const opts = this.mergeOptions({ url, ...options })
    const axiosInstance = axios.create()
    // 添加拦截器
    this.setInterceptor(axiosInstance, opts, resolveError)
    // 当调用axios.request 时 内部会创建一个 axios实例 并且给这个实例传入配置属性
    return axiosInstance(opts)
  }
  get(url, config = {}, resolveError) {
    return this.request(url, config, resolveError)
  }
  post(url, config = {}, resolveError) {
    config = { ...config, method: 'post' }
    return this.request(url, config, resolveError)
  }
  fixData(data) {
    for (let [key, value] of Object.entries(data)) {
      if (Array.isArray(value) || isPlainObject(value)) {
        this.fixData(value)
      } else {
        data[key] = protocolFixed(value)
      }
    }
    return data
  }
  install(Vue) {
    Vue.prototype.$http = this
  }
}

export default new HttpRequest()
